import { pdfToOffice } from '@src/js/common/ark-extensions/dc-components/pdf-to-office';
import { browser } from '@src/slide/application/service/edit-extension/edit-extension-export';
import { Feature } from '@tencent/workbench';
import { isLogin } from '@src/js/common/utils';
import BaseToolbarFeature from '../../common/feature/base-toolbar-feature';

export enum ConversionType {
    PDF_TO_WORD = 'pdf2word',
    PDF_TO_EXCEL = 'pdf2excel',
    PDF_TO_PPT = 'pdf2ppt'
}
enum OperationSystem {
    WINDOWS = 'wd',
    MAC = 'mac'
}
enum App {
    WX_MINI = 'wxsp',
    DESK = 'desk',
    WEB = 'web'
}

@Feature()
export class PdfTransformFeature extends BaseToolbarFeature {
    /**
     * 文档权限
     */
    public pdfToOffice(type: ConversionType) {
        pdfToOffice({
            versForReport: {
                ver9ForModalToPayPopup: 'pc_slidetoolbar',
                aidPrefix: this.getAidPrefix(type),
            },
            tab: type,
            // FIXME 这里会存在层级遮挡的问题，PDF转换开通会员的弹框和工具栏-格式转换-PDF转换下拉框的层级是一样的。如果设置pdf转换弹框的层级高于工具栏，开通会员的弹框就会被遮挡。
            // 这里目前只能等格式转换组件@marveli更换为dui，但是这里优先级比较低。https://git.woa.com/tencent-doc-core/workbench/issues/381
            style: { zIndex: '999' },
        });
    }

    public isHistoryShown() {
        return this.getAppService().editableServiceLayer?.historyManager.isShown();
    }

    protected getCustomDisabledState(): boolean {
        return this.isHistoryShown() || !isLogin();
    }

    private getAidPrefix(type: ConversionType): string {
        const osPrefix = browser.isWindows ? OperationSystem.WINDOWS : OperationSystem.MAC; // 或其它平台
        const appPrefix = browser.isWxMiniProgram ? App.WX_MINI
            : (browser.isTencentDocDesktopApp ? App.DESK : App.WEB);
        const aidPrefixMap = {
            [ConversionType.PDF_TO_WORD]: `txdocs_${osPrefix}_${appPrefix}_slidetoolbar`,
            [ConversionType.PDF_TO_EXCEL]: `txdocs_${osPrefix}_${appPrefix}_slidetoolbar`,
            [ConversionType.PDF_TO_PPT]: `txdocs_${osPrefix}_${appPrefix}_slidetoolbar`,
        };
        return aidPrefixMap[type];
    }
}
